package com.heelion.farmafreelance.push

import androidx.compose.runtime.Composable

@Composable
actual fun rememberPushNotifiche(): PushNotifiche? = WebPushNotifiche

/**
 * Notifiche push web: la logica sta in src/webPush/resources/farmy-push.js (Firebase JS),
 * caricato da index.html. Qui si chiama solo window.farmyPush() e si passa il token all'app.
 */
private object WebPushNotifiche : PushNotifiche {
    override fun attiva(onToken: (token: String, piattaforma: String) -> Unit) {
        val promessa = js("(typeof window !== 'undefined' && window.farmyPush) ? window.farmyPush() : null")
        if (promessa == null) {
            println("--- [PUSH] farmy-push.js non caricato ---")
            return
        }
        promessa.then { token: dynamic ->
            if (token != null) onToken(token as String, "WEB")
        }
    }
}
